import React from 'react';

// components
import { Box, FormControl, FormErrorMessage, FormLabel, Input, Stack } from '@chakra-ui/react';
import { FormState, UseFormRegister } from 'react-hook-form';
import { testSchemaType } from './test-schema';

interface ITestForm {
    loading: boolean;
    register: UseFormRegister<testSchemaType>;
    formState: FormState<testSchemaType>;
}

export const TestForm = (props: ITestForm): JSX.Element => {
    const { loading, register, formState } = props;

    return (
        <Stack spacing='24px'>
            <Box>
                <FormControl  isInvalid={!!formState?.errors?.name?.message} mt={2}>
                    <FormLabel htmlFor='nombre'>Nombre</FormLabel>
                    <Input
                        id='nombre'
                        type='text'
                        placeholder='Ej. Hematologia'
                        focusBorderColor='primary.400'
                        bg={'white'}
                        disabled={loading}
                        {...register('name', { required: true })}
                    />
                    <FormErrorMessage>
                        {formState.errors.name && formState.errors.name.message}
                    </FormErrorMessage>
                </FormControl>

            </Box>
        </Stack>
    );
};
